import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=4eec7475&scoped=true&"
import script from "./login2.vue?vue&type=script&lang=js&"
export * from "./login2.vue?vue&type=script&lang=js&"
import style0 from "./login2.vue?vue&type=style&index=0&id=4eec7475&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec7475",
  null
  
)

export default component.exports